// extracted by mini-css-extract-plugin
export default {"mCard":"Dt-z","image":"Et-z","imageNoBackground":"Ft-z","fullWidth":"Gt-z"};